import { Injectable } from '@angular/core';
import { PackingBoxCreateLabelService } from '../../../../views/packing-box/dialog/create-label/create-label.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CompoundingPackingBoxCreateLabelType } from './create-label.component';
import { PackingBoxCreateLabelType } from '../../../../views/packing-box/types/create-label-dialog';

@Injectable()
export class CompoundingCreateLabelService extends PackingBoxCreateLabelService {
  formBatches = new FormGroup({
    workOrderBatch: new FormControl<number>(undefined),
    search: new FormControl<string>(undefined),
  });

  setBatchesToRequired(): void {
    this.formBatches.get('workOrderBatch').setValidators([Validators.required]);
    this.formBatches.get('workOrderBatch').updateValueAndValidity();
  }

  override onSave(
    data: CompoundingPackingBoxCreateLabelType['data']
  ):
    | CompoundingPackingBoxCreateLabelType['response']
    | PackingBoxCreateLabelType['response'] {
    console.log('hola mundo  4');
    const res = super.onSave(data);
    if (data.batches.length > 0 && this.formBatches.invalid) {
      this.alertService.error('Necesitas seleccionar un batch');
      return undefined;
    }
    if (data.batches.length === 0) {
      return res;
    }
    const woBatch = data.batches.find(
      (b) => b.id === this.formBatches.get('workOrderBatch').value
    );
    const result = {
      ...res,
      workOrderBatchId: this.formBatches.get('workOrderBatch').value,
      batch: `${woBatch.batch.workOrder.transactionNumber} | ${woBatch.batch.batchNumber}`,
    };
    console.log('hola mundo');
    console.log(result);
    return result;
  }
}
